
export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyCENRwJQcORrlDkWjE-ePzf6e8ofoSwyz8',
    authDomain: 'i-ganhei.firebaseapp.com',
    databaseURL: 'https://i-ganhei.firebaseio.com',
    projectId: 'i-ganhei',
    storageBucket: 'i-ganhei.appspot.com',
    messagingSenderId: '325663902287'
  }
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts